let cartesianInstance;
let polarInstance;
class CartesianSeriesTypes {
  constructor() {
    this.types = new Set();
    if (cartesianInstance) {
      throw new Error('You can only create one instance!');
    }
    cartesianInstance = this.types;
  }
  addType(value) {
    this.types.add(value);
  }
  getTypes() {
    return this.types;
  }
}
class PolarSeriesTypes {
  constructor() {
    this.types = new Set();
    if (polarInstance) {
      throw new Error('You can only create one instance!');
    }
    polarInstance = this.types;
  }
  addType(value) {
    this.types.add(value);
  }
  getTypes() {
    return this.types;
  }
}
export const cartesianSeriesTypes = new CartesianSeriesTypes();
cartesianSeriesTypes.addType('bar');
cartesianSeriesTypes.addType('line');
cartesianSeriesTypes.addType('scatter');
export const polarSeriesTypes = new PolarSeriesTypes();
polarSeriesTypes.addType('radar');